import { input, output, viewChild } from '@angular/core';
import { SCHWAB_TERMS_AND_CONDITIONS } from 'AccountsApp/ts/constants/integrations.constants';
import { SchwabIntegrationService } from 'IntegrationsApp/ts/services/schwab-integration-service';
import { ConfirmModalModule } from 'Angular/features/components/modals/confirm-modal/confirm-modal.module';
import * as i0 from "@angular/core";
import * as i1 from "IntegrationsApp/ts/services/schwab-integration-service";
import * as i2 from "../../../../../../../ycharts/static/ts/features/components/modals/confirm-modal/confirm-modal.component";
const _c0 = ["modal"];
export class SchwabActivateModalComponent {
    constructor(schwabIntegrationService) {
        this.schwabIntegrationService = schwabIntegrationService;
        this.clientId = input.required(...(ngDevMode ? [{ debugName: "clientId" }] : []));
        this.oauthUrl = input.required(...(ngDevMode ? [{ debugName: "oauthUrl" }] : []));
        this.redirectUri = input.required(...(ngDevMode ? [{ debugName: "redirectUri" }] : []));
        this.rpmAuth = input(false, ...(ngDevMode ? [{ debugName: "rpmAuth" }] : []));
        this.declined = output();
        this.modal = viewChild.required('modal');
        this.innerHtml = `${'<div style="overflow: scroll; height: 20em">' +
            '<p><strong>To connect your Schwab integration to YCharts, log in to your Schwab account.</strong></p>\n' +
            "<p>Once you log into your Schwab account from this portal, you'll return to YCharts and be able to import holdings from Schwab.</p>" +
            '<br>'}${SCHWAB_TERMS_AND_CONDITIONS}</div>`;
    }
    openModal() {
        this.modal().openModal();
    }
    onConfirm(confirmed) {
        if (confirmed) {
            this.schwabIntegrationService.getOAuthRandomState(this.rpmAuth()).subscribe({
                next: (data) => {
                    window.location.href = `${this.oauthUrl()}?client_id=${this.clientId()}&redirect_uri=${this.redirectUri()}&state=${data.state}`;
                },
                error: () => {
                    this.declined.emit();
                },
            });
        }
        else {
            this.declined.emit();
        }
    }
}
SchwabActivateModalComponent.ɵfac = function SchwabActivateModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SchwabActivateModalComponent)(i0.ɵɵdirectiveInject(i1.SchwabIntegrationService)); };
SchwabActivateModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SchwabActivateModalComponent, selectors: [["ycn-schwab-activate-modal"]], viewQuery: function SchwabActivateModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuerySignal(ctx.modal, _c0, 5);
    } if (rf & 2) {
        i0.ɵɵqueryAdvance();
    } }, inputs: { clientId: [1, "clientId"], oauthUrl: [1, "oauthUrl"], redirectUri: [1, "redirectUri"], rpmAuth: [1, "rpmAuth"] }, outputs: { declined: "declined" }, decls: 2, vars: 3, consts: [["modal", ""], [3, "confirmHandler", "confirmButtonText", "confirmHeader", "confirmText"]], template: function SchwabActivateModalComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "ycn-confirm-modal", 1, 0);
        i0.ɵɵlistener("confirmHandler", function SchwabActivateModalComponent_Template_ycn_confirm_modal_confirmHandler_0_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onConfirm($event)); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("confirmButtonText", "Log in to Schwab")("confirmHeader", "Activate Schwab Integration")("confirmText", ctx.innerHtml);
    } }, dependencies: [ConfirmModalModule, i2.ConfirmModalComponent], encapsulation: 2 });
